import React, { useState, useEffect } from 'react';
import { getSupabase } from './supabase';
import moment from 'moment';
import './App.css';
import { IoStatsChartOutline, IoCashOutline, IoCarOutline } from "react-icons/io5";
import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";

const vehicleTypes = ['Fura', 'Kamaz', 'Stoyanka', 'Gazel'];
// const rates = { 'Fura': 15000, 'Kamaz': 10000, 'Stoyanka': 5000, 'Gazel': 5000 };

const formatPrice = (price) => {
  return (price && price !== null) ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '';
};

// To'lanmadi

function Statistics() {
  const [stats, setStats] = useState({
    total: 0,
    entered: 0,
    exited: 0,
    revenue: 0,
    typeBreakdown: vehicleTypes.reduce((acc, type) => ({ ...acc, [type]: 0 }), {}),
  });
  const [dateFilter, setDateFilter] = useState('Бугунги');
  const [selectedDate, setSelectedDate] = useState(moment().format('YYYY-MM-DD'));
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchStats = async () => {
      setIsLoading(true);
      try {
        const supabase = await getSupabase();
        let query = supabase.from('vehicles').select('*');

        if (dateFilter === 'Бугунги') {
          const startOfDay = moment().startOf('day').toISOString();
          const endOfDay = moment().endOf('day').toISOString();
          query = query.or(
            `and(status.eq.Turibti,entry_date.gte.${startOfDay},entry_date.lte.${endOfDay}),and(status.eq.Chiqdi,exit_date.gte.${startOfDay},exit_date.lte.${endOfDay}),and(status.eq."To'lanmadi",exit_date.gte.${startOfDay},exit_date.lte.${endOfDay})`
          );
        } else if (dateFilter === 'Бошка сана' && selectedDate) {
          const startOfDay = moment(selectedDate).startOf('day').toISOString();
          const endOfDay = moment(selectedDate).endOf('day').toISOString();
          query = query.or(
            `and(status.eq.Turibti,entry_date.gte.${startOfDay},entry_date.lte.${endOfDay}),and(status.eq.Chiqdi,exit_date.gte.${startOfDay},exit_date.lte.${endOfDay}),and(status.eq."To'lanmadi",exit_date.gte.${startOfDay},exit_date.lte.${endOfDay})`
          );
        }

        const { data, error } = await query;

        if (error) {
          console.error('Ошибка получения данных:', error);
          return;
        }

        const total = data.length;
        const entered = data.filter(v => v.status === 'Turibti').length;
        const exited = data.filter(v => v.status === 'Chiqdi').length + data.filter(v => v.status === "To'lanmadi").length;
        const revenue = data
          .filter(v => v.status === 'Chiqdi')
          .reduce((sum, v) => sum + v.paid_amount, 0);

        const typeBreakdown = vehicleTypes.reduce((acc, type) => {
          const count = data.filter(v => v.type === type).length;
          return { ...acc, [type]: count };
        }, {});

        setStats({ total, entered, exited, revenue, typeBreakdown });
      } catch (err) {
        console.error('Ошибка при загрузке статистики:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStats();
  }, [dateFilter, selectedDate]);

  return (
    <div className="container">
      <h2 style={{ margin: 0, marginTop: 5, marginBottom: 5, marginLeft: 5, color: '#3b82f6'}}> <IoStatsChartOutline /> Statistika</h2>
      <div style={{ display: 'flex', paddingBottom: 5, flexDirection: 'column' }}>
        <select
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
          style={{ padding: 10, border: "1px solid #bbbbbb", borderRadius: 10, fontSize: 18 }}
        >
          <option value="Бугунги">Бугунги</option>
          <option value="Бошка сана">Бошка сана</option>
          <option value="Хамма">Хамма</option>
        </select>
        {dateFilter === 'Бошка сана' && (
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            style={{ marginTop: 5, padding: 10, border: "1px solid #bbbbbb", borderRadius: 10, fontSize: 18 }}
          />
        )}
      </div>

      {isLoading ? (
        <div>Yuklanmoqda...</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column' }} >
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 5 }}>
            <div className="statisticsDivP" style={{ backgroundColor: '#059783' }}> <strong> <IoCashOutline /> {formatPrice(stats.revenue) + " so'm"}</strong> <p> Daromad </p> </div>
            <div className="statisticsDivP" style={{ backgroundColor: '#3182ce' }}> <strong> <IoCarOutline /> {stats.total} ta</strong> <p> Hamma moshinalar</p> </div>
            <div className="statisticsDivP" style={{ backgroundColor: '#2666a3' }}> <strong> <IoMdArrowRoundBack />  {stats.exited}</strong><p> Chiqgan </p> </div>
            <div className="statisticsDivP" style={{ backgroundColor: '#0e8d7c' }}> <strong> <IoMdArrowRoundForward /> {stats.entered}</strong> <p> Kirgan </p> </div>
          </div>

          <div className="statistics" style={{ display: 'flex', flexDirection: 'column', gap: 5, marginTop: 5 }} >
            {vehicleTypes.map(type => (
              <p key={type} style={{ marginTop: 0, marginBottom: 0, borderRadius: 10 }}>
                <strong>{stats.typeBreakdown[type] || 0} ta {type}</strong>
              </p>
            ))}
          </div>
        </div>
      )}
      <div style={{ marginTop: '5em'}}> </div>

    </div>
  );
}

export default Statistics;